import { kDefaultEmployeeViews } from "@coreapp/constants";

export class QChartMetadata {
  constructor() {
    this.ID = null;
    this.name = null;
    this.fields = {};
    this.views = [];
    this.subchartrule = {};
    this.import = {};
    this.maxQueryLimit = [];
    this.assistants = {};
    this.sync = {};
    this.append = [];
    this.headers = [];
    this.topBoxID = null;
    this.topBoxName = null;
    this.shortcuts = [];
    this.RefreshTime = null;
    this.Timestamp = null;
    this.employeesCollection = null;
    this.subchartsCollection = null;
    this.boxcount = null;
    this.orphans = null;
    this.merge = [];
    this.filters = [];
  }

  SetDefaultValues() {
    this.fields = {
      SupervisorID: null,
      PersonID: null,
      Name: null,
      Title: null,
      aTitle: null,
      Division: null,
      "Preferred Last": null,
      "Last Name": null,
      "First Name": null,
      "Preferred First": null,
      Location: null
    };
    this.views = [...kDefaultEmployeeViews];
    this.subchartrule = {
      minsubsforbreak: "5",
      startbreaksat: "2",
      breakevery: "2",
      nameusing: "Title",
      scChartBreakType: 1,
      pagedensity: 0
    };
    this.import = { source: "" };
    this.maxQueryLimit = [200, 20000];
    this.assistants = { assistantrule: "isAssistant equals 1" };
    this.sync = { schedule: "Off", diagnostics: {} };
  }

  GetMetadataObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
